var _style, _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBcuWhiteTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 165.01 64.39",
    style: {
      enableBackground: "new 0 0 165.01 64.39"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000095321869413015760650000011624484122753118117_);}\n\t.st1{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 165.01,
    height: 64.39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000088110605046321910070000012683998845910989444_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000088110605046321910070000012683998845910989444_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.58,83.46c4.3,3.96,11.01,3.68,14.97-0.62l31.99-34.74c3.96-4.3,3.68-11.01-0.62-14.97l-0.28-0.26 c-2.07-1.91-4.77-2.89-7.61-2.78c-2.84,0.12-5.45,1.32-7.36,3.39L79.68,68.23C75.72,72.53,76,79.24,80.3,83.2L80.58,83.46z  M75.29,35.42l-0.28-0.26c-2.07-1.91-4.78-2.9-7.61-2.78c-2.84,0.12-5.45,1.32-7.36,3.39L28.05,70.51 c-3.96,4.3-3.68,11.01,0.62,14.97l0.28,0.26c4.3,3.96,11.01,3.68,14.97-0.62l31.99-34.74C79.86,46.09,79.59,39.37,75.29,35.42z  M93.14,26.9c5.9-0.24,10.5-5.24,10.26-11.14c-0.24-5.9-5.24-10.5-11.14-10.26c-5.9,0.24-10.5,5.24-10.26,11.14 C82.24,22.54,87.24,27.14,93.14,26.9z M62.44,91.72c-5.9,0.24-10.5,5.24-10.26,11.14c0.12,2.86,1.34,5.5,3.45,7.44 c2.1,1.94,4.84,2.94,7.7,2.82c5.9-0.24,10.5-5.24,10.26-11.14C73.34,96.08,68.34,91.47,62.44,91.72z M128.66,84.56 c-2.07-1.91-4.77-2.89-7.61-2.78c-2.84,0.12-5.45,1.32-7.36,3.39l-31.99,34.74c-3.96,4.3-3.68,11.01,0.62,14.97l0.28,0.26 c4.3,3.96,11.01,3.68,14.97-0.62l31.98-34.74c3.96-4.3,3.68-11.01-0.62-14.97L128.66,84.56z M145.92,54.9 c-5.9,0.24-10.5,5.24-10.26,11.14c0.24,5.9,5.24,10.5,11.14,10.26c5.9-0.24,10.5-5.24,10.26-11.14 C156.82,59.26,151.82,54.65,145.92,54.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBcuWhiteTop);
export default __webpack_public_path__ + "static/media/bcu_white_top.557d9d22c312d9b64ea158e81c4939c5.svg";
export { ForwardRef as ReactComponent };